module.exports = __webpack_public_path__ + "677c7d3292c2fd8212dbb3f5da058b0a.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-106@2x.png
// module id = 492
// module chunks = 0